import {t} from "@lingui/core/macro";
import * as React from "react";

import IconButton from "@khanacademy/wonder-blocks-icon-button";
import type {EmojiSentiment} from "@khan/guide-types";

import {sharedStyles} from "./message-and-context-bubble-shared-styles.ts";
import emojiForReaction from "./utils/emoji-for-reaction.ts";

interface Props {
    disabled?: boolean;
    sentiment: EmojiSentiment;
    onClick: (reaction: EmojiSentiment) => unknown;
}

const MessageReactionButton = (props: Props): React.ReactElement | null => {
    const {disabled, sentiment, onClick} = props;
    const emoji = emojiForReaction(sentiment);
    if (!emoji) {
        return null;
    }

    const sentiments = {
        "thumbs-up": t`thumbs-up`,
        "thumbs-down": t`thumbs-down`,
    };

    return (
        <IconButton
            icon={emoji}
            aria-label={sentiments[sentiment]}
            disabled={disabled}
            kind="tertiary"
            onClick={() => onClick(sentiment)}
            testId={"msg-react-" + sentiment}
            size="xsmall"
            style={sharedStyles.wcagAATargetSize}
        />
    );
};

export {MessageReactionButton};
